<template>
  <div class="content" style="padding: 16px 0">
    <!-- Header -->
    <v-card outlined style="border-top: 3px solid #e2007a; margin-bottom: 16px">
      <v-card-text style="display: flex; align-items: center; justify-content: space-between; padding: 16px">
        <div>
          <div style="font-size: 16px; font-weight: bold; color: #333">Documentation API SEGUR</div>
          <div style="font-size: 12px; color: #888; margin-top: 4px">
            Specification OpenAPI pour l'integration de votre logiciel avec le serveur d'enrolement SEGUR V2
          </div>
        </div>
        <v-btn small outlined color="#e2007a" @click="downloadJson" :disabled="!spec">
          <v-icon small left>mdi-download</v-icon>
          Telecharger JSON
        </v-btn>
      </v-card-text>
    </v-card>

    <!-- Loading -->
    <div v-if="loading" style="text-align: center; padding: 60px">
      <v-progress-circular indeterminate color="#e2007a" size="40"></v-progress-circular>
      <div style="margin-top: 12px; color: #888; font-size: 13px">Chargement de la documentation...</div>
    </div>

    <!-- Erreur -->
    <div v-else-if="error" style="text-align: center; padding: 40px; color: #f44336">
      <v-icon color="red" large>mdi-alert-circle-outline</v-icon>
      <div style="margin-top: 8px">Impossible de charger la documentation</div>
      <div style="font-size: 12px; color: #999; margin-top: 4px">{{ error }}</div>
      <v-btn small text color="#e2007a" style="margin-top: 12px" @click="loadSpec">Reessayer</v-btn>
    </div>

    <!-- Redoc container -->
    <div v-show="!loading && !error" ref="redocContainer" class="redoc-wrapper"></div>
  </div>
</template>

<script>
import axios from "axios";
import server from "@/store/server";

const API_BASE = server.url;

export default {
  name: "SegurDoc",
  data() {
    return {
      loading: true,
      error: null,
      spec: null,
    };
  },
  mounted() {
    this.loadSpec();
  },
  methods: {
    async loadSpec() {
      try {
        this.loading = true;
        this.error = null;

        const res = await axios.get(`${API_BASE}/segur/api-spec`, {
          headers: server.getHeader(),
        });

        this.spec = res.data;
        await this.initRedoc(this.spec);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error("[SegurDoc] Erreur:", err.message);
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },

    async initRedoc(spec) {
      if (window.Redoc) {
        this.renderRedoc(spec);
        return;
      }

      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = "https://cdn.redoc.ly/redoc/latest/bundles/redoc.standalone.js";
        script.onload = () => {
          this.renderRedoc(spec);
          resolve();
        };
        script.onerror = () => reject(new Error("Echec du chargement de Redoc"));
        document.head.appendChild(script);
      });
    },

    renderRedoc(spec) {
      if (!this.$refs.redocContainer) return;
      this.$refs.redocContainer.innerHTML = "";

      window.Redoc.init(
        spec,
        {
          theme: {
            colors: {
              primary: { main: "#e2007a" },
              success: { main: "#4caf50" },
              warning: { main: "#ff9800" },
              error: { main: "#f44336" },
              text: { primary: "#333333" },
            },
            typography: {
              fontSize: "14px",
              fontFamily: '"Roboto", sans-serif',
              headings: { fontFamily: '"Roboto", sans-serif' },
            },
            sidebar: {
              backgroundColor: "#fafafa",
              textColor: "#333333",
              activeTextColor: "#e2007a",
            },
            rightPanel: {
              backgroundColor: "#263238",
            },
          },
          hideDownloadButton: true,
          hideLoading: true,
          expandResponses: "200,201",
          pathInMiddlePanel: true,
          sortPropsAlphabetically: false,
          nativeScrollbars: true,
          menuToggle: true,
          hideHostname: false,
          noAutoAuth: true,
        },
        this.$refs.redocContainer
      );
    },

    downloadJson() {
      if (!this.spec) return;
      const blob = new Blob([JSON.stringify(this.spec, null, 2)], { type: "application/json" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "segur-api-partner.json");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    },
  },

  beforeDestroy() {
    if (this.$refs.redocContainer) {
      this.$refs.redocContainer.innerHTML = "";
    }
  },
};
</script>

<style scoped>
.redoc-wrapper {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: auto;
  height: calc(100vh - 200px);
}
</style>

<style>
/* Masquer le footer "API docs by Redocly" */
.redoc-wrapper a[href*="redocly"],
.redoc-wrapper div[class*="powered"] {
  display: none !important;
}
</style>
